<template>
  <div class="home">
    <!--    <img :src="require('@/assets/home/img_home.png')" class="home-top-bg"/>-->
    <div class="header">
      <div class="container">
        <div class="logo"><img :src="require('@/assets/logo_home@2x.png')" style="width: 0.72rem;"/></div>
        <a-menu mode="horizontal" style="min-width: 5.4001rem;">
          <a-menu-item :key="item.name" v-for="(item, index) in menuList">
            <a
              :class="'home-menu'"
              @click="$router.push(item.path)"
              href="javascript:">{{item.title}}</a>
          </a-menu-item>
        </a-menu>
        <div>
          <a class="avatar-group" href="javaScript:" v-if="!userData">
            <a-button
              @click="handleLogin"
              shape="round"
              size="large"
              type="primary">
              登录
            </a-button>
            <a-button
              @click="handleRegister"
              class="register-button"
              shape="round"
              size="large">
              注册
            </a-button>
          </a>
          <a-dropdown class="user-box" v-if="userData">
            <a-menu slot="overlay">
              <template v-for="(item,index) in mineMenuList">
                <a-menu-item :key="index+1">
                  <a @click="$router.push(item.url)" :class="item.nav===$route.meta.nav?'on':''" class="nav-li" href="javaScript:">
                    <div class="nav-label">{{item.name}}</div>
                    <a-icon class="icon-right" type="right"/>
                  </a>
                </a-menu-item>
              </template>
              <a-menu-item key="6">
                <a @click="handleLogout" class="nav-li" href="javaScript:">
                  <div class="nav-label">退出登录</div>
                  <a-icon class="icon-right" type="right"/>
                </a>
              </a-menu-item>
            </a-menu>
            <a class="avatar-group" href="javaScript:">
              <div class="user">{{userData.name}}</div>
              <a-avatar :src="require('@/assets/user/user_default@2x.png')" class="avatar"/>
            </a>
          </a-dropdown>
        </div>
      </div>
    </div>
    <div class="home-content">
      <div class="title-first">吉林省继续教育培训基地</div>
      <div class="title-second">吉林省信息技术应用创新人才培训平台</div>
      <div class="home-button">
        <a-button
          @click="$router.push('/home/study')"
          shape="round"
          size="large"
          type="primary">
          去学习
        </a-button>
        <a-button
          @click="$router.push('/home/whole')"
          class="choose-course-btn"
          shape="round"
          size="large">
          去选课
        </a-button>
      </div>
      <div class="home-news">
        <div class="carousel-parent">
          <a-carousel :autoplaySpeed="5000" autoplay ref="carousel" v-if="carouselList.length>0">
            <div :key="item.id" @click="goToNewsDetail(item)" v-for="(item, index) in carouselList">
              <img
                :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
                class="carousel-img"/>
              <div :title="item.title" class="carousel-title">{{ item.title }}</div>
            </div>
          </a-carousel>
        </div>
        <div class="fixed-parent">
          <div :key="item.id" @click="goToNewsDetail(item)" class="home-fixed-item" v-for="item in homeNewsList">
            <img
              :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
              class="fixed-img"/>
            <div :title="item.title" class="fixed-title">{{ item.title }}</div>
          </div>
        </div>
      </div>
      <!--  课程体系   -->
      <div class="home-card">
        <div class="home-card-title">
          <div class="home-title">课程体系</div>
          <div @click="$router.push('/home/whole')" class="home-show-all">查看全部<img
            :src="require('@/assets/icons/arrow_right@2x.png')"
            style="width: 0.24rem;"/>
          </div>
        </div>
        <a-tabs
            type='card'
            @change="buttonClick"
            class='type-tab-wrapper'
            tab-position="top"
          >
            <a-tab-pane   v-for="i in enableOptions.wholeType" :key="i.value" :tab="`${i.label}`">
            </a-tab-pane>
          </a-tabs>
        <div class="home-card-list">
          <div style="width: 100%;display:flex;flex-direction:column;justify-content: center;align-items: center;" v-if="wholeList && wholeList.length === 0">
            <img
              :src="require('@/assets/icons/no_data@2x.png')"
              style="width: 150px"/>
            <div class="no-data-text">暂无数据</div>
          </div>
          <div
            @click="goToCourse(item)"
            :class="(index + 1) % 4 === 0 ? 'home-card-item' : 'home-card-item home-card-item-space'"
            :key="item.id"
            v-for="(item, index) in wholeList"
            v-if="wholeList.length > 0">
            <img
              :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
              class="home-card-item-img"/>
            <div class="home-card-item-message">
              <div class="home-card-item-name">{{ item.name }}</div>
              <div class="home-card-item-content">支付方式：{{ options.payType && options.payType.filter(type => item.payType.split(',').indexOf(type.value)!==-1).map(type => type.label).join('，') }}</div>
              <div class="home-card-item-content">学时：<span class="home-card-item-hour">{{ item.classHour }}</span></div>
            </div>
          </div>
        </div>
      </div>
      <!--  去学习   -->
      <div class="home-card">
        <div class="home-card-title">
          <div class="home-title">去学习</div>
          <div @click="$router.push('/home/study')" class="home-show-all">查看全部<img
            :src="require('@/assets/icons/arrow_right@2x.png')"
            style="width: 0.24rem;"/>
          </div>
        </div>
        <div class="home-card-list">
          <div style="width: 100%;display:flex;flex-direction:column;justify-content: center;align-items: center;" v-if="homeCourseList && homeCourseList.length === 0">
            <img
              :src="require('@/assets/icons/no_data@2x.png')"
              style="width: 150px"/>
            <div class="no-data-text">暂无数据</div>
          </div>
          <div
            @click="goToVideo(item)"
            :class="(index + 1) % 4 === 0 ? 'home-card-item' : 'home-card-item home-card-item-space'"
            :key="item.id"
            v-for="(item, index) in homeCourseList"
            v-if="homeCourseList.length > 0">
            <img
              :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
              class="home-card-item-img"/>
            <div class="home-card-item-message">
              <div class="home-card-item-name">{{ item.name }}</div>
              <!--              <div class="home-card-item-content">课程名称：{{ item.courseName }}</div>-->
              <div class="home-card-item-content">课程分类：{{ item.categoryName }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--  试卷信息   -->
      <div class="home-card" v-if="userData">
        <div class="home-card-title">
          <div class="home-title">试卷信息</div>
        </div>
        <a-card>
          <s-table
            :columns="columns"
            :data="loadData"
            :scroll="{ x:1280 }"
            class="scroll-table-wrap"
            ref="table"
            rowKey="id"
            size="default"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="startExam(record)">答题</a>
            </span>
          </s-table>
        </a-card>
      </div>
      <!--  实操信息   -->
      <div class="home-card" v-if="userData">
        <div class="home-card-title">
          <div class="home-title">实操信息</div>
        </div>
        <a-card>
          <s-table
            :columns="speakingTasksColumns"
            :data="speakingTasksLoadData"
            :scroll="{ x:1280 }"
            class="scroll-table-wrap"
            ref="table"
            rowKey="id"
            size="default"
          >
            <span slot="action" slot-scope="text, record">
              <a @click="startSpeakingTasks(record)">实操</a>
            </span>
          </s-table>
        </a-card>
      </div>
    </div>
    <div class="home-foot">
      <teacher-modal ref="teacherModal"/>
      <!--  教师团队   -->
      <div class="home-card">
        <div class="home-card-title">
          <div class="home-title">教师团队</div>
          <div @click="$router.push('/home/teacher')" class="home-show-all">查看全部<img
            :src="require('@/assets/icons/arrow_right@2x.png')"
            style="width: 0.24rem;"/>
          </div>
        </div>
        <div class="home-card-list">
          <div style="width: 100%;display:flex;flex-direction:column;justify-content: center;align-items: center;" v-if="teacherList.length === 0">
            <img
              :src="require('@/assets/icons/no_data@2x.png')"
              style="width: 150px"/>
            <div class="no-data-text">暂无数据</div>
          </div>
          <div
            @click="$refs.teacherModal.show(item.id)"
            :class="(index + 1) % 4 === 0 ? 'home-teacher-item' : 'home-teacher-item home-card-item-space'"
            :key="item.id"
            v-for="(item, index) in teacherList"
            v-if="teacherList.length > 0">
            <img
              :src="item.attachmentList&&item.attachmentList.length>0?baseUrl + item.attachmentList[0].url:''"
              class="home-teacher-item-img"/>
            <div class="home-teacher-item-message">
              <div class="home-teacher-item-name">{{ item.name }}</div>
              <div class="home-teacher-item-content">{{ item.employer }}-{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
      <div style="height:1.9rem;" v-if="teacherList.length === 0"/>
      <div class="home-foot-message">
        <div class="home-foot-about">友情链接：<a :key="item.id" style="white-space: nowrap;" v-for="item in friendSiteList" target="_blank" :href="item.url">{{item.name}}</a></div>
        <div class="home-foot-address">地址：长春市新民大街1381号</div>
        <div class="home-foot-phone">联系电话：{{$t('base.telephone')}}</div>
        <img
          :src="require('@/assets/icons/img_sydw@2x.png')"
          style="height: 0.48rem;margin-top: 0.24rem"/>
      </div>
    </div>
  </div>
</template>
<script>
  import STable from '@/components/table/'
  import ShowModal from '../store/showModal'
  import home from '../api/home'
  import { mapState } from 'vuex'
  import examList from '../api/examList'
  import speakingTasksList from '../api/speakingTasks'
  import TeacherModal from './teacher/TeacherModal'
  import { getListByCode,enableListByCode } from '../api/dict'
  import { examStart } from '@/api/exam'
  import { speakingTasksStart } from '@/api/speaking'

  export default {
    name: 'home',
    components: {
      STable,
      ShowModal,
      TeacherModal
    },
    data() {
      return {
        isHome: 1,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 10 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        col: 24 / 1,
        form: this.$form.createForm(this),
        systemName: process.env.VUE_APP_HEADER,
        columns: [
          {
            title: '试卷名称',
            dataIndex: 'testPaperName',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'courseDateRange' }
          },
          {
            title: '班级',
            dataIndex: 'className',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '班主任',
            dataIndex: 'headmaster',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '状态',
            dataIndex: 'status',
            className: 'min-wid-s',
            ellipsis: true,
            customRender: text => {
              const target = this.options.examStatus && this.options.examStatus.filter(item => text + '' === item.value)[0]
              return target && target.label
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'action' }
          }
        ],
        speakingTasksColumns: [
          {
            title: '实操任务名称',
            dataIndex: 'speakingTasksName',
            className: 'min-wid-m',
          },
          {
            title: '班级',
            dataIndex: 'className',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '班主任',
            dataIndex: 'headmaster',
            className: 'min-wid-s',
            ellipsis: true
          },
          {
            title: '状态',
            dataIndex: 'status',
            className: 'min-wid-s',
            ellipsis: true,
            customRender: text => {
              const target = this.options.examStatus && this.options.examStatus.filter(item => text + '' === item.value)[0]
              return target && target.label
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            className: 'min-wid-m',
            scopedSlots: { customRender: 'action' }
          }
        ],
        baseUrl: process.env.VUE_APP_BASE_URL,
        menuList: [
          {
            title: '课程体系',
            name: 'whole',
            path: '/home/whole'
          }, {
            title: '去学习',
            name: 'study',
            path: '/home/study'
          }, {
            title: '试卷信息',
            name: 'testPaper',
            path: '/home/testPaper'
          }, {
            title: '教师团队',
            name: 'teacher',
            path: '/home/teacher'
          }, {
            title: '新闻动态',
            name: 'news',
            path: '/home/news'
          }, {
            title: '联系我们',
            name: 'about',
            path: '/home/about'
          }
        ],
        mineMenuList: [
          {
            name: '个人信息',
            nav: 'personal',
            url: '/home/personal'
          }, {
            name: '我选的课',
            nav: 'myCourse',
            url: '/home/myCourse'
          }, {
            name: '我的签到',
            nav: 'mySign',
            url: '/home/mySign'
          }, {
            name: '我的考试',
            nav: 'myExam',
            url: '/home/myExam'
          }, {
            name: '我的实操任务',
            nav: 'mySpeakingTasksList',
            url: '/home/mySpeakingTasksList'
          }, {
            name: '班级通讯录',
            nav: 'classBook',
            url: '/home/classBook'
          }
        ],
        carouselList: [],
        homeNewsList: [],
        wholeList: [],
        homeCourseList: [],
        teacherList: [],
        friendSiteList: [],
        dictCode: 'paperType,examStatus,payType,wholeType',
        options: {},
        enableOptions: {},
        parameters: { testPaperPublishId: '',classId:'' },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          const transferQuery = {
            status: '1'
          }
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return examList.getMyExamList(Object.assign(transferQuery, page))
        },
        speakingTasksLoadData: parameter => {
          const transferQuery = {
            status: '1'
          }
          const order = parameter.sortOrder !== undefined ? parameter.sortOrder.substring(0, parameter.sortOrder.length - 3) : ''
          const page = {
            pageNo: parameter.pageNo,
            pageSize: parameter.pageSize,
            sortField: parameter.sortField,
            draw: order
          }
          return speakingTasksList.getMySpeakingTasksList(Object.assign(transferQuery, page))
        }
      }
    },
    filters: {},
    computed: {
      ...mapState({
        userData: state => {
          if (state.user.userData.name) {
            return state.user.userData
          } else {
            return JSON.parse(localStorage.getItem('user'))
          }
        }
      })
    },
    methods: {
      buttonClick(value){
        if(value==='全部'){
          home.getHomeWholeList().then(res => {
              this.wholeList=res.result.list
          })
        }else {
          home.getHomeWholeList({type:value}).then(res => {
              this.wholeList=res.result.list
          })
        }
      },
      openNew() {
      },
      handleLogin() {
        ShowModal.$emit('showLogin', true)
      },
      handleRegister() {
        ShowModal.$emit('showRegister', true)
      },
      handleLogout() {
        ShowModal.$emit('showLogout', true)
      },
      goToNewsDetail(record) {
        this.$router.push('/home/news/newsDetail')
        sessionStorage.setItem('newsId', record.id)
      },
      goToCourse(record) {
        this.$router.push('/home/homeWholeCourse')
        sessionStorage.setItem('wholeId', record.id)
        sessionStorage.setItem('wholeName', record.name)
        sessionStorage.setItem('wholeAmount', record.amount)
        sessionStorage.setItem('payType', record.payType)
        sessionStorage.setItem('wholeRemarks', record.remarks)
      },
      goToVideo(record) {
        sessionStorage.setItem('courseId', record.id)
        sessionStorage.setItem('isTry', '1')
        this.$router.push('/home/studyVideoDetail')
      },
      startExam(record) {
        const exam = {
          testPaperPublishId: record.id,
          classId: record.classId,
          duration: record.duration,
          isPaging: record.isPaging,
          pageSize: record.pageSize
        }
        this.parameters.testPaperPublishId = record.id
        this.parameters.classId = record.classId
        this.parameters.wholeId = record.wholeId
        examStart(this.parameters).then(res => {
          sessionStorage.setItem('exam', JSON.stringify(exam))
          this.questionNumList = res.result.list
          if (this.questionNumList !== undefined) {
            this.questionNumList.forEach(item => {
              item.active = false
            })
            this.questionNumList[0].active = true
            this.questionNumList.splice(0, 0)
          }
          this.$router.push('/home/homeExamMsgCard')
        })
      },
      startSpeakingTasks(record) {
        const speakingTasks = {
          speakingTasksPublishId: record.id,
          classId: record.classId,
          duration: record.duration,
        }
        this.parameters.speakingTasksPublishId = record.id
        this.parameters.classId = record.classId
        this.parameters.wholeId = record.wholeId
        speakingTasksStart(this.parameters).then(res => {
          sessionStorage.setItem('speakingTasks', JSON.stringify(speakingTasks))
          this.$router.push('/home/homeSpeakingTasksMsgCard')
        })
      },
      requestData() {
        this.$store.commit('SET_APP_SPINNING', true)
        Promise.all([
          home.getAllNewsDynamic(),
          home.getHomeWholeList(),
          home.getCourseList(),
          home.getHomeTeacherList(),
          getListByCode({ dictCode: this.dictCode }).then(res => {
            this.options = { ...this.options, ...res.result.dictDefine }
          }),
          home.getFriendSite(),
          enableListByCode({dictCode: this.dictCode}).then(res => {
            if (res.result.dictDefine.wholeType){
              res.result.dictDefine.wholeType.unshift({value:'全部',label:'全部'})
            }
            this.enableOptions = {...this.enableOptions, ...res.result.dictDefine}
          }),
        ]).then(res => {
          this.carouselList = res[0].result.carousel
          this.homeNewsList = res[0].result.fixedShow
          this.wholeList = res[1].result.list
          this.homeCourseList = res[2].result.list
          this.teacherList = res[3].result.list
          this.friendSiteList = res[5].result.list
          setTimeout(() => {
            this.$store.commit('SET_APP_SPINNING', false)
          }, 500)
        }).catch(() => {
          setTimeout(() => {
            this.$store.commit('SET_APP_SPINNING', false)
          }, 500)
        })
      }
    },
    //获取数据`
    created() {
      ShowModal.$on('refreshHome', val => {  //接收 save.vue 中传过来的 data_1 的值
        this.requestData()
      })
      this.requestData()
    }
  }
</script>
<style lang="less">
  .home {
    background-image: url("../assets/home/img_home@2x.png");
    background-color: #f6f9fc;
    background-position: left top;
    background-size: 100% auto;
    background-repeat: no-repeat;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    min-width: 14.1604rem;

    .header {
      display: block;
      justify-content: center;

      .container {
        background: rgba(0, 0, 0, 0);
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 0.975rem;
        margin: 0 auto;
        padding: 0 1.455rem 0;

        .logo {
          padding: 0 0.075rem;
          font-size: 0.15rem;
          font-weight: 600;
          line-height: 0.165rem;
          min-width: max-content;
        }

        .ant-menu-horizontal {
          border: 0;
          background: transparent;
          line-height: 0;

          li {
            cursor: pointer;
            font-size: 0.105rem;
            font-weight: 400;

            a {
              font-size: 0.15rem;
            }

            border: 0;
          }
        }

        .home-menu {
          color: rgba(255, 255, 255, 0.8);
          font-weight: 400;
          font-size: 0.16rem;
          line-height: 0.22rem;
        }

        .ant-menu-item-active {
          a {
            color: #f3f1fc;
          }
        }

        .ant-menu-item-selected {
          a {
            color: rgba(255, 255, 255, 0.8);
          }
        }

        .ant-menu-submenu-selected {
          background: #f3f1fc;
          font-weight: 600;
        }

        .ant-menu-submenu-open {
          /*background: #751212;*/
        }

        .submenu-title-wrapper {
          color: rgba(255, 255, 255, 0.8);
        }

        .ant-menu-item-selected:after {
          content: '';
          align-items: center;
          position: absolute;
          left: 0;
          top: 0.3rem;
          bottom: auto;
          right: 0;
          margin: auto;
          height: 0.015rem;
          width: 0.195rem;
          background-color: rgba(255, 255, 255, 0);
        }

        .ant-menu-item:hover:after, .ant-menu-item-active:after {
          content: '';
          align-items: center;
          position: absolute;
          left: 0;
          top: 0.3rem;
          bottom: auto;
          right: 0;
          margin: auto;
          height: 0.015rem;
          width: 0.195rem;
          background-color: #f3f1fc;
        }

        .avatar-group {
          color: #fff !important;
          display: flex;
          align-items: center;

          .ant-btn-round {
            border-radius: 0.075rem;
          }

          .ant-btn-primary {
            background-color: rgba(0, 0, 0, 0);
            border-color: rgba(0, 0, 0, 0);
            color: rgba(255, 255, 255, 0.6);
          }

          .register-button {
            margin-left: 0.075rem;
            background-color: rgba(0, 0, 0, 0);
            border-color: rgba(255, 255, 255, 0.6);
            color: rgba(255, 255, 255, 0.6);
          }

        }

        .user-box {
          align-self: flex-start;
          height: 0.48rem;
          flex-shrink: 0;
          justify-content: flex-end;
          text-align: right;

          .user {
            font-size: 0.135rem;
          }

          .avatar {
            margin-left: 0.075rem;
          }
        }

        .ant-dropdown-menu {
          .nav-li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 0.12rem;
            color: #5A7184;
            min-height: 0.3rem;

            .nav-label {
              min-width: 0.8rem;
            }

            .icon-right {
              font-size: 0.075rem;
              color: #5A7184;
            }

            &.on {
              .nav-label {
                color: #1565D8;
                font-weight: bold;
              }

              .icon-right {
                color: #1565D8;
              }
            }
          }
        }
      }

    }

    .home-content {
      box-sizing: border-box;
      padding: 0.4rem 1.455rem 0;

      .title-first {
        font-weight: 200;
        color: #ffffff;
        margin-left: 0.72rem;
        font-size: 0.22rem;
        line-height: 0.24rem;
        margin-top: 0.3rem;
      }

      .title-second {
        font-weight: 600;
        color: #ffffff;
        font-size: 0.36rem;
        line-height: 0.44rem;
        margin-left: 0.705rem;
        margin-top: 0.15rem;
      }

      .home-button {
        margin-left: 0.705rem;
        margin-top: 0.225rem;

        .ant-btn-round {
          border-radius: 0.075rem;
        }

        .ant-btn-primary {
          width: 1.575rem;
          height: 0.48rem;
          font-size: 0.195rem;
          background-color: rgba(23, 77, 244, 1);
          border-color: rgba(23, 77, 244, 1);
          color: rgba(255, 255, 255, 1);
        }

        .choose-course-btn {
          margin-left: 0.15rem;
          width: 1.575rem;
          height: 0.48rem;
          font-size: 0.195rem;
          background-color: rgba(0, 0, 0, 0);
          border-color: rgba(255, 255, 255, 1);
          color: rgba(255, 255, 255, 1);
        }
      }

      .home-news {
        display: flex;
        margin-top: 0.9075rem;
        height: 3.6001rem;

        .carousel-parent {
          width: 7.6352rem;
          margin-right: 0.15rem;
        }

        .ant-carousel .slick-slide {
          text-align: center;
          width: 7.6352rem;
          height: 3.6001rem;
          overflow: hidden;
        }

        .ant-carousel .slick-dots {
          text-align: left;
          padding-left: 0.15rem;
          margin-bottom: 0.075rem;
        }

        .carousel-title {
          background: rgba(79, 79, 79, 0.1);
          width: 7.6352rem;
          height: 0.3rem;
          text-align: left;
          position: absolute;
          font-size: 0.24rem;
          color: white;
          padding: 0.075rem 0 0.4875rem 0.15rem;
          bottom: 0;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .slick-dots {
          margin-bottom: 0 !important;
        }

        .carousel-img {
          width: 7.6352rem;
          height: 3.6001rem;
          position: absolute;
          cursor: pointer;
          object-fit: cover;
          top: 0;
          border-radius: 0.0375rem;
        }

        .fixed-parent {
          width: 3.7501rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: space-between;

          .home-fixed-item {
            width: 1.725rem;
            height: 1.725rem;
            position: relative;
            cursor: pointer;
          }

          .fixed-img {
            height: 1.725rem;
            width: 1.725rem;
            border-radius: 0.0375rem;
            object-fit: cover;
          }

          .fixed-title {
            background: rgba(79, 79, 79, 0.1);
            position: absolute;
            max-height: 0.43rem;
            left: 0;
            bottom: 0;
            width: 1.725rem;
            color: white;
            font-size: 0.12rem;
            padding: 0.05rem 0.075rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }

      }
    }

    .home-card {
      margin-top: 0.795rem;
      padding-top: 0.195rem;
      position: relative;

      .home-card-title {
        display: flex;
        justify-content: space-between;

        .home-title {
          font-weight: 600;
          color: #191d28;
          font-size: 0.24rem;
          line-height: 0.3rem;
        }

        .home-show-all {
          color: #79818d;
          font-size: 0.16rem;
          line-height: 0.2rem;
          text-align: right;
          cursor: pointer;
        }
      }

        .type-tab-wrapper{
          margin-top: 30px;
        }
        .type-tab-wrapper > .ant-tabs-bar {
          border-bottom:0px !important;
        }

        .type-tab-wrapper > .ant-tabs-bar > .ant-tabs-nav-container > .ant-tabs-nav-wrap > .ant-tabs-nav-scroll > .ant-tabs-nav > div >  .ant-tabs-tab {
          background-color:#ffffff;
          color:#183b56;
          font-size:16px;
          margin-right: 0;
        }s
        .type-tab-wrapper > .ant-tabs-bar > .ant-tabs-nav-container{
          display: flex;
        }

      .type-tab-wrapper > .ant-tabs-bar > .ant-tabs-nav-container > .ant-tabs-nav-wrap > .ant-tabs-nav-scroll > .ant-tabs-nav > div >  .ant-tabs-tab-active {
        color:#ffffff;
        font-size:16px;
        background:#174df4 !important;
        margin-right: 0;
      }

      .home-card-list {
        display: flex;
        flex-wrap: wrap;

        .home-card-item {
          width: 2.7151rem;
          margin-top: 0.18rem;
          background-color: white;
          border-radius: 0.0375rem;
          cursor: pointer;
          box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
          -webkit-box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
          -moz-box-shadow: 0rem 0.0225rem 0.0225rem #c8c8c8;
        }

        .home-card-item-space {
          margin-right: 0.15rem;
        }

        .home-card-item-message {
          padding: 0.1575rem 0.15rem 0.21rem 0.12rem;

          .home-card-item-name {
            height: 0.405rem;
            font-weight: 600;
            color: #191d28;
            font-size: 0.16rem;
            line-height: 0.2rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }

          .home-card-item-content {
            color: #79818d;
            margin-top: 0.12rem;
            font-size: 0.1275rem;
            line-height: 0.18rem;
          }

          .home-card-item-hour {
            color: #f16695;
          }
        }

        .home-card-item-img {
          width: 2.7226rem;
          height: 1.53rem;
          border-top-left-radius: 0.0375rem;
          border-top-right-radius: 0.0375rem;
          object-fit: cover;
        }

        .home-teacher-item {
          position: relative;
          width: 2.7151rem;
          height: 3.1951rem;
          margin-top: 0.18rem;
          background-color: white;
          border-radius: 0.0375rem;
          cursor: pointer;
        }

        .home-teacher-item-img {
          width: 2.7226rem;
          height: 3.1951rem;
          border-radius: 0.0375rem;
          object-fit: cover;
        }

        .home-teacher-item-message {
          background: rgba(255, 255, 255, 0.75);
          position: absolute;
          left: 0;
          bottom: 0;
          width: 2.7226rem;
          color: white;
          font-size: 0.12rem;
          padding: 0.15rem 0.1275rem 0.15rem 0.1275rem;
          border-bottom-left-radius: 0.04rem;
          border-bottom-right-radius: 0.04rem;

          .home-teacher-item-name {
            font-weight: 600;
            color: #424b5f;
            font-size: 0.15rem;
            letter-spacing: 0.002rem;
            line-height: 0.2rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .home-teacher-item-content {
            color: #79818d;
            font-size: 0.1275rem;
            margin-top: 0.075rem;
            line-height: 0.18rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

        }
      }

      .ant-card-bordered {
        border: 0;
        margin-top: 0.3rem;
      }

      .ant-table-placeholder {
        border-top: 1px solid rgba(246, 249, 252, 1);
        border-bottom: 1px solid rgba(246, 249, 252, 1);
      }

      .ant-table-thead {
        height: 0.375rem;
      }

      .ant-table-thead > tr > th {
        background: rgba(246, 249, 252, 1);
      }

      .ant-table-tbody > tr > td {
        border-bottom: 0.0075rem solid rgba(246, 249, 252, 1);
      }
    }

    .home-card:after {
      content: '';
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      bottom: auto;
      right: auto;
      margin: auto;
      height: 0.0225rem;
      width: 0.3975rem;
      background-color: #0f6aeb;
    }

    .home-foot {
      min-height: 9.3752rem;
      background-image: url("../assets/home/img_home_bottom@2x.png");
      background-position: left bottom;
      background-size: 100% auto;
      background-repeat: no-repeat;
      box-sizing: border-box;
      padding: 0.4rem 1.455rem 0;

      .home-foot-message {
        margin-top: 0.9975rem;
        text-align: center;
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.16rem;
        letter-spacing: 0.002rem;
        line-height: 0.2rem;

        .home-foot-about {
          font-weight: 600;

          a {
            color: rgba(255, 255, 255, 0.8);
            margin-right: 0.1125rem;
          }
        }

        .home-foot-address, .home-foot-phone {
          margin-top: 0.24rem;
          font-weight: 400;
        }
      }
    }
  }
</style>
